<template>
    <Modal v-model="mailShow" width="408" class-name="vertical-mail-modal" @on-visible-change="mailHide">
        <div class="mail-container">
            <div class="mail-header">
                <div class="line"></div>
                <img src="@/assets/svg/mail.svg"/>
            </div>

            <div class="mail-content-text">
                <div style="margin-bottom: 14px">亲爱的超级校友：</div>
                <div style="margin-bottom: 6px"> 欢迎各位进入专属打造的iCourt企业法律服务中台数据库：</div>
                <div class="e-section-container">
                    <div class="e-section">
                        <label class="e-title">产品手册库 ：</label>
                        <label class="e-content">
                            法律服务产品化是大势所趋，对外增强客户服务体验的可视化感知，对内提升团队协同办案标准。该库涵盖各大热门专业与行业，以客户视角编纂，方便我们谈案与报价，给足客户买单的冲动。
                        </label>
                    </div>
                    <div class="e-section">
                        <label class="e-title">对企课程库 ：</label>
                        <label class="e-content">讲课，是律师开拓市场最优雅的方式。这里的课程，不定位专业法律知识的传播，而定位为激发客户的法律服务需求，推动客户与律师产生链接，建立更强信任。</label>
                    </div>
                    <div class="e-section">
                        <label class="e-title">技能课程库 ：</label>
                        <label class="e-content">授人以鱼不如授人以渔，在这里，我们解读了企法中台数据库中给大家准备的"内容弹药"背后的方法和原理，帮助大家提升市场拓展技能，掌握个性化修订方法。</label>
                    </div>
                    <div class="e-section">
                        <label class="e-title">服务模板库 ：</label>
                        <label class="e-content">该库汇集行业中为客户制作的常用手册，包括但不限于《指南手册》《报价文件》 《诉讼策略报告
                            》《服务报告》等模板，不仅有专家团队的最佳实践示范，而且有精美的设计排版。</label>
                    </div>
                    <div class="e-section">
                        <label class="e-title">大数据报告 ：</label>
                        <label class="e-content">针对热门业务、焦点行业的法律问题，我们在这里给大家准备好了《大数据报告》、《白皮书》等法律大数据实务研究成果，一方面帮助咱们在办案研究时更快速和深度了解行业与专业，另一方面在线下谈案、拜访客户时，给到客户看得见、摸得着的专业呈现与服务体验。</label>
                    </div>
                    <div style="color:#ed6c00;">iCourt企业法律服务中台数据库里的内容会持续升级扩充，与校友相伴前行。</div>
                </div>
            </div>
            <div class="gery-area"></div>

            <div class="bottom-btn">
                <button @click="mailHide()">
                    <span class="one one-arrow-right"></span>
                    进入法律服务中台
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
    export default {
        name: "Mail",
        props: {mailShow: Boolean},
        methods: {
            mailHide(flag) {
                if (flag) {
                    return
                }
                this.$emit('updateHide', false)
            }
        }
    }
</script>

<style lang="scss">
    .vertical-mail-modal .ivu-modal-content {
        background: inherit;
        box-shadow: none;

        .ivu-modal-close {
            display: none;
        }

        .close-icon {
            color: white;
            width: 28px;
            z-index: 100;
            position: relative;
            left: 50%;
            top: 20px;
            cursor: pointer;

            &:hover {
                color: #ED6C00;
            }
        }

        .ivu-modal-footer {
            display: none;
        }

        .mail-container {
            position: relative;
            width: 480px;
            height: 600px;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
            border-radius: 9px;
            background: #ffffff;

            .mail-header {
                display: block;
                text-align: center;
                height: 57px;
                position: relative;
                padding-top: 40px;

                img {
                    position: absolute;
                    z-index: 2;
                    left: 140px;
                    background: white;
                    width: 206px;
                    right: 0;
                    margin-top: -20px;
                }
            }

            .mail-content-text {
                &::-webkit-scrollbar {
                    display: none;
                }

                margin: auto;
                margin-top: 20px;
                left: 0;
                right: 0;
                position: absolute;
                width: 379px;
                height: 452px;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 200%;
                overflow: auto;
                color: #000000;
                padding-bottom: 20px;

                .e-section-container {
                    .e-section {
                        margin-bottom: 20px;
                    }

                    .e-title {
                        font-size: 12px;
                        color: #ED6C00;
                        width: 80px;
                        display: inline-block;
                        vertical-align: top;
                    }

                    .e-content {
                        width: 294px;
                        display: inline-block;
                    }
                }
            }

            .gery-area {
                position: absolute;
                width: 480px;
                height: 20px;
                bottom: 80px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.02) 100%);
            }

            .bottom-btn {
                text-align: center;
                position: absolute;
                bottom: 8px;
                height: 70px;
                background: #FFFFFF;
                border-radius: 0px 0px 9px 9px;
                width: 100%;

                button {
                    outline: none;
                    cursor: pointer;
                    width: 170px;
                    height: 36px;
                    line-height: 30px;
                    color: #ED6C00;
                    font-size: 13px;
                    background: white;
                    border-radius: 18px;
                    display: inline-block;
                    margin-top: 17px;
                    border: 1px solid #ed6c00;
                    .one {
                        color: #ED6C00;
                        font-size: 18px;
                        position: relative;
                        top: 3px
                    }
                }

            }

        }
    }

    .vertical-mail-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }

</style>